import axios from 'axios';
import { BASE_URL } from './config';

axios.defaults.withCredentials = true
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, 
});

api.interceptors.request.use((config) => {
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const currentUrl = window.location.pathname;
    if (error.response && error.response.status === 403) {   
       
      if((/^\/datasets\/.+/.test(currentUrl))){

      //Remove cookies by setting them to expire
      document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      document.cookie = "amr_user_roles=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        window.location.href = '/authenticate'; 
      }
       
    }

    return Promise.reject(error);
  }
);

export default api;
